// extracted by mini-css-extract-plugin
export default {"container":"CopilotCodingAgentQuotaBanner-module__container--vyBW6"};